const colors = {
  MAIN_COLOR: '#229892',
  FONT_COLOR: '#47505E',
  LIGHT_FONT_COLOR: '#767B84',
  BORDER_COLOR:'#D1D3D9',
  WHITE_COLOR:'#fff',
  BLACK_COLOR:"#000"
}

export default colors;
